import _classCallCheck from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @module ol/renderer/Composite
 */
import MapRenderer from './Map.js';
import ObjectEventType from '../ObjectEventType.js';
import RenderEvent from '../render/Event.js';
import RenderEventType from '../render/EventType.js';
import { CLASS_UNSELECTABLE } from '../css.js';
import { checkedFonts } from '../render/canvas.js';
import { inView } from '../layer/Layer.js';
import { listen, unlistenByKey } from '../events.js';
import { replaceChildren } from '../dom.js';
/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */

var CompositeMapRenderer = /*#__PURE__*/function (_MapRenderer) {
  _inherits(CompositeMapRenderer, _MapRenderer);

  var _super = _createSuper(CompositeMapRenderer);

  /**
   * @param {import("../Map.js").default} map Map.
   */
  function CompositeMapRenderer(map) {
    var _this;

    _classCallCheck(this, CompositeMapRenderer);

    _this = _super.call(this, map);
    /**
     * @type {import("../events.js").EventsKey}
     */

    _this.fontChangeListenerKey_ = listen(checkedFonts, ObjectEventType.PROPERTYCHANGE, map.redrawText.bind(map));
    /**
     * @private
     * @type {HTMLDivElement}
     */

    _this.element_ = document.createElement('div');
    var style = _this.element_.style;
    style.position = 'absolute';
    style.width = '100%';
    style.height = '100%';
    style.zIndex = '0';
    _this.element_.className = CLASS_UNSELECTABLE + ' ol-layers';
    var container = map.getViewport();
    container.insertBefore(_this.element_, container.firstChild || null);
    /**
     * @private
     * @type {Array<HTMLElement>}
     */

    _this.children_ = [];
    /**
     * @private
     * @type {boolean}
     */

    _this.renderedVisible_ = true;
    return _this;
  }
  /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */


  _createClass(CompositeMapRenderer, [{
    key: "dispatchRenderEvent",
    value: function dispatchRenderEvent(type, frameState) {
      var map = this.getMap();

      if (map.hasListener(type)) {
        var event = new RenderEvent(type, undefined, frameState);
        map.dispatchEvent(event);
      }
    }
  }, {
    key: "disposeInternal",
    value: function disposeInternal() {
      unlistenByKey(this.fontChangeListenerKey_);
      this.element_.parentNode.removeChild(this.element_);

      _get(_getPrototypeOf(CompositeMapRenderer.prototype), "disposeInternal", this).call(this);
    }
    /**
     * Render.
     * @param {?import("../Map.js").FrameState} frameState Frame state.
     */

  }, {
    key: "renderFrame",
    value: function renderFrame(frameState) {
      if (!frameState) {
        if (this.renderedVisible_) {
          this.element_.style.display = 'none';
          this.renderedVisible_ = false;
        }

        return;
      }

      this.calculateMatrices2D(frameState);
      this.dispatchRenderEvent(RenderEventType.PRECOMPOSE, frameState);
      var layerStatesArray = frameState.layerStatesArray.sort(function (a, b) {
        return a.zIndex - b.zIndex;
      });
      var viewState = frameState.viewState;
      this.children_.length = 0;
      /**
       * @type {Array<import("../layer/BaseVector.js").default>}
       */

      var declutterLayers = [];
      var previousElement = null;

      for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
        var layerState = layerStatesArray[i];
        frameState.layerIndex = i;
        var layer = layerState.layer;
        var sourceState = layer.getSourceState();

        if (!inView(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
          layer.unrender();
          continue;
        }

        var element = layer.render(frameState, previousElement);

        if (!element) {
          continue;
        }

        if (element !== previousElement) {
          this.children_.push(element);
          previousElement = element;
        }

        if ('getDeclutter' in layer) {
          declutterLayers.push(
          /** @type {import("../layer/BaseVector.js").default} */
          layer);
        }
      }

      for (var _i = declutterLayers.length - 1; _i >= 0; --_i) {
        declutterLayers[_i].renderDeclutter(frameState);
      }

      replaceChildren(this.element_, this.children_);
      this.dispatchRenderEvent(RenderEventType.POSTCOMPOSE, frameState);

      if (!this.renderedVisible_) {
        this.element_.style.display = '';
        this.renderedVisible_ = true;
      }

      this.scheduleExpireIconCache(frameState);
    }
  }]);

  return CompositeMapRenderer;
}(MapRenderer);

export default CompositeMapRenderer;